//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan'
export default {
  name: "sup-ass-flow",
  props: ['dataId','dataImg'],
  components:{
    DivSpan
  },
  data(){
    return{
      supAssFlow: {},
      index: 1,
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
        {icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'考核评分'},
        {icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
      ],
      supList:[],
      selectorSupNum:0,
      scoreIndex:0
    }
  },
  methods:{
    // 判断输入最大值
    onBlur(e,max,item){
      if(e.supAssPerson.actualResult && !isNaN(e.supAssPerson.actualResult)){
        item['use'] = true;
        let a = parseFloat(e.supAssPerson.actualResult + '');
        if(Number(a) > Number(max) ){
          this.$vux.toast.text(`该项指标最高分为${max}`);
          e.supAssPerson.actualResult = max;
        } else {
          e.supAssPerson.actualResult = Number(a)
        }
      } else {
        e.supAssPerson.actualResult = 0
      }
    },
    getBaseDto(){
      this.$loadingShow();
      this.$get(`api/sup-ass-flow/${this.dataId}`).then((data) => {
        if(data){
          this.supAssFlow = data;
          this.supAssFlow['periodType'] = data.supAssResults[0].periodType;
          this.supAssFlow['belongYear'] = data.supAssResults[0].belongYear;
          this.supAssFlow['belong'] = data.supAssResults[0].belong;
          this.supAssFlow.supAssPlanTypeDtoList.forEach((supAssPlanType) => {
            supAssPlanType.supAssResultDtList.forEach((supAssResultDt) => {
              if (supAssResultDt.resultType == '101' || supAssResultDt.resultType == '103') {
                this.supAssFlow.supAssResults.forEach((supplier) => {
                  supplier.supAssResultDts.forEach((resultDt) => {
                    if (resultDt.supAssPlanDtCode == supAssResultDt.supAssPlanDtCode) {
                      this.scoreChange(supAssResultDt, resultDt);
                      return;
                    }
                  });
                });
              }
            });
          });
          for(let i = 0;i < this.supAssFlow.supAssResults.length;i++){
            let obj = {
              num:i,
              supName:this.supAssFlow.supAssResults[i].supplierName
            }
            this.supList.push(obj);
          }
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    //  计算考核指标分数
    scoreChange(scoreItem, supplierItem) {
      supplierItem.supAssPerson.score = 0;
      if (scoreItem.supAss.scoreType == '101') {
        supplierItem.supAssPerson.score = Number(supplierItem.supAssPerson.actualResult);
        if (scoreItem.supAss.lowerLimit) {
          scoreItem.supAss.lowerLimit = Number(scoreItem.supAss.lowerLimit);
        }
        if (scoreItem.supAss.upperLimit) {
          scoreItem.supAss.upperLimit = Number(scoreItem.supAss.upperLimit);
        }
        if (scoreItem.supAss.toInitScore) {
          supplierItem.supAssPerson.score = supplierItem.supAssPerson.score + scoreItem.supAss.initScore;
        }
        if (scoreItem.supAss.lowerLimit && supplierItem.supAssPerson.score < scoreItem.supAss.lowerLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.lowerLimit;
        } else if (scoreItem.supAss.upperLimit && supplierItem.supAssPerson.score > scoreItem.supAss.upperLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.upperLimit;
        } else {
          supplierItem.supAssPerson.confirmScore = supplierItem.supAssPerson.score;
        }
      } else if (scoreItem.supAss.scoreType == '102') {
        scoreItem.supAss.supAssDts.forEach((item) => {
          if (item.lowerLimit) {
            item.lowerLimit = Number(item.lowerLimit);
          }
          if (item.upperLimit) {
            item.upperLimit = Number(item.upperLimit);
          }
          if (!item.lowerLimit && supplierItem.supAssPerson.actualResult <= item.upperLimit) {
            supplierItem.supAssPerson.score = item.score;
          } else if (item.lowerLimit && item.upperLimit) {
            if (supplierItem.supAssPerson.actualResult >= item.lowerLimit && supplierItem.supAssPerson.actualResult <= item.upperLimit) {
              supplierItem.supAssPerson.score = item.score;
            }
          } else if (!item.upperLimit && supplierItem.supAssPerson.actualResult >= item.lowerLimit) {
            supplierItem.supAssPerson.score = item.score;
          }
        });
        if (scoreItem.supAss.toInitScore) {
          supplierItem.supAssPerson.score = supplierItem.supAssPerson.score + scoreItem.supAss.initScore;
        }
        if (scoreItem.supAss.lowerLimit && supplierItem.supAssPerson.score < scoreItem.supAss.lowerLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.lowerLimit;
        } else if (scoreItem.supAss.upperLimit && supplierItem.supAssPerson.score > scoreItem.supAss.upperLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.upperLimit;
        } else {
          supplierItem.supAssPerson.confirmScore = supplierItem.supAssPerson.score;
        }
      } else if (scoreItem.supAss.scoreType == '103') {
        if (scoreItem.supAss.optionType == '102') {
          let scoreList = supplierItem.supAssPerson.actualResult.split(',');
          let scoreAll = 0;
          scoreList.forEach((data) => {
            scoreItem.supAss.supAssDts.forEach((item) => {
              if (item.code == data) {
                scoreAll += item.score;
              }
            });
          });
          supplierItem.supAssPerson.score = scoreAll;
        } else {
          scoreItem.supAss.supAssDts.forEach((item) => {
            if (item.code == supplierItem.supAssPerson.actualResult) {
              supplierItem.supAssPerson.score = item.score;
            }
          });
        }
        if (scoreItem.supAss.toInitScore) {
          supplierItem.supAssPerson.score = supplierItem.supAssPerson.score + scoreItem.supAss.initScore;
        }
        if (scoreItem.supAss.lowerLimit && supplierItem.supAssPerson.score < scoreItem.supAss.lowerLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.lowerLimit;
        } else if (scoreItem.supAss.upperLimit && supplierItem.supAssPerson.score > scoreItem.supAss.upperLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.upperLimit;
        } else {
          supplierItem.supAssPerson.confirmScore = supplierItem.supAssPerson.score;
        }
      } else if (scoreItem.supAss.scoreType == '104') {
        supplierItem.supAssPerson.score = scoreItem.supAss.initScore + scoreItem.supAss.supAssDts[0].score * Math.floor(supplierItem.supAssPerson.actualResult / scoreItem.supAss.supAssDts[0].lowerLimit);
        if (scoreItem.supAss.lowerLimit && supplierItem.supAssPerson.score < scoreItem.supAss.lowerLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.lowerLimit;
        } else if (scoreItem.supAss.upperLimit && supplierItem.supAssPerson.score > scoreItem.supAss.upperLimit) {
          supplierItem.supAssPerson.confirmScore = scoreItem.supAss.upperLimit;
        } else {
          supplierItem.supAssPerson.confirmScore = supplierItem.supAssPerson.score;
        }
      }
    },
    itemTab(index) {
      this.index = index;
      if(index === 3){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },
    //切换评分项
    scoreIndexChange(index){
      this.scoreIndex = index;
    },
    //切换供应商
    supChange(e){
      this.scoreIndex = 0;
    },
    indexOf(str,par){
      if(!str){
        str = '';
      }
      return str.indexOf(par) != -1;
    },
    valid(){
      let validBol = true;
      this.supAssFlow.supAssResults.forEach((supplier) => {
        supplier.supAssResultDts.forEach((assResult) => {
          if (!assResult.supAssPerson.actualResult && assResult.supAssPerson.actualResult !== 0) {
            this.supAssFlow.supAssPlanTypeDtoList.forEach((supAssPlanList) => {
              for (let i = 0; i < supAssPlanList.supAssResultDtList.length; i++) {
                if (supAssPlanList.supAssResultDtList[i].supAssPlanDtCode === assResult.supAssPlanDtCode) {
                  if (supAssPlanList.supAssResultDtList[i].visible) {
                    assResult.visible = true;
                    if (supAssPlanList.supAssResultDtList[i].processible) {
                      validBol = false;
                      this.$vux.toast.text(`供应商${supplier.supplierName}指标${supAssPlanList.supAssResultDtList[i].supAss.name}未评分，请前往pc端评分`);
                    } else {
                      assResult.supAssPerson.score = supAssPlanList.supAssResultDtList[i].supAss.initScore;
                      assResult.supAssPerson.confirmScore = supAssPlanList.supAssResultDtList[i].supAss.initScore;
                    }
                  } else {
                    assResult.visible = false;
                  }
                  return;
                }
              }
            });
          }
        });
      });
      return validBol;
    },
    formData(){
      return this.supAssFlow;
    }
  },
  mounted(){
    if(this.dataId){
      this.getBaseDto();
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-assess/sup-ass-flow.vue